window.addEventListener("DOMContentLoaded", ()=> {
  var JSONProduct = JSON.parse(document.querySelector('[data-section-type="static-product"]')?.innerHTML).product;
  var JSONCartProducts = document.querySelector('[data-section-type="shipping-cart-items"]') ? JSON.parse(document.querySelector('[data-section-type="shipping-cart-items"]')?.innerHTML): '';
  var ratesWrapper = document.querySelector('[data-product-shipping-rates]');
  var ratesResponse = document.querySelector('[data-product-shipping-response]');
  var shippingCalculate = document.querySelector('[data-product-shipping-submit]');
  var productQuantity = document.getElementById('product-quantity-select');
  var shippingToggle = document.querySelector('[data-product-shipping-toggle]');
  var shippingCalculatorWrapper = document.querySelector('[data-cartshipping]');
  var currentProductQuantity = productQuantity?.value;

  var data = {
    "destination":{
       "country":"AU",
       "postal_code": "",
       "province": "",
       "city":"",
       "name":"",
       "address1": null,
       "address2":"",
       "address3":null,
       "phone":"",
       "fax":null,
       "address_type":null,
       "company_name":""
    },
    "items": [
      JSONCartProducts
    ],
    "currency": window.Theme.currency
  }

  data.items.unshift({
    "name": `${JSONProduct.title}`,
    "sku":"",
    "quantity": currentProductQuantity,
    "grams": JSONProduct.variants[0].weight,
    "price": JSONProduct.price,
    "vendor": `${JSONProduct.vendor}`,
    "requires_shipping":true,
    "taxable":true,
    "fulfillment_service":"manual",
    "properties":null,
    "product_id": JSONProduct.id,
    "variant_id": JSONProduct.variants[0].id
  });

  // Validation states
  var checkState = (postcode) => {
    if ((postcode >= 1000 && postcode <=1999) || (postcode >= 2000 && postcode <= 2599) || (postcode >=2619 && postcode <= 2899) || (postcode >= 2921 && postcode <= 2999)){
        return 'NSW';
    } else if ((postcode >= 200 && postcode <= 299) || (postcode >= 2600 && postcode <= 2618) || (postcode >= 2900 && postcode <= 2920)) {
        return 'Australian Capital Territory';
    } else if ((postcode >= 3000 && postcode <= 3999) || (postcode >= 8000 && postcode <= 8999)) {
        return 'VIC';
    } else if ((postcode >= 4000 && postcode <= 4999) || (postcode >= 9000 && postcode <= 9999)) {
        return 'QLD';
    } else if ((postcode >= 5000 && postcode <= 5799) || (postcode >= 5800 && postcode <= 5999)) {
        return 'SA';
    } else if ((postcode >= 6000 && postcode <= 6797) || (postcode >= 6800 && postcode <= 6999)) {
        return 'WA';
    } else if ((postcode >= 7000 && postcode <= 7799) || (postcode >= 7800 && postcode <=7999)) {
        return 'TAS';
    } else if ((postcode >= 800 && postcode <= 899) || (postcode >= 900 && postcode <= 999)) {
        return 'NT';
    }

    return '';
  }

  // Bespoke shipping API
  
  var productShippingCalculate = function(data) {
    fetch("https://parcel-intelligence.com/cs/api_ex.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "HTTP_X_STORE_NAME": "kentstreetcellars.myshopify.com",
          "HTTP_X_STORE_TOKEN": "3afe82a8be0ffe7de6743ddd9ce7f5e9c479c1e2"
        },
        body: JSON.stringify(data),
      }).then((response) => { 
       setTimeout( function() {
         return response.json().then((data) => {
           shippingResultsHtml(data.rates);
          }).catch((err) => {
            // ERROR
          });
       },600);
    });
  }

  // Display shipping results
  var shippingResultsHtml = (results) => {
    var ratesHtml = '';
    //var resultsOrder = results.sort((a, b) => parseInt(a.total_price) - parseInt(b.total_price));
    results.forEach(element => {
      var price = (element.total_price == 0) ? `${window.Theme.freeLabel}` : Shopify.formatMoney(element.total_price, window.Theme.moneyFormat);
      ratesHtml += `<li>
          <p class="shipping-name-wrapper">
            <span class="shipping-name">${element.service_name}</span>
            ${element.description ? `<span class="shipping-description">${element.description}</span>` : ``}
          </p>
          <h3>${price}</h3>
        </li>`;
    });

    if(ratesWrapper) {
      ratesResponse.classList.remove('hide');
      ratesWrapper.innerHTML = ratesHtml;
    }

    shippingCalculate.innerHTML = window.Theme.calculateLabel;
    return ratesHtml;
  }
  
  // Calculate shipping 
  shippingCalculate?.addEventListener('click', (e) => {
    var shippingProvince = document.getElementById('address_province').value;
    var shippingZip = document.getElementById('address_zip').value;
    var state = checkState(shippingZip);

    
    ratesResponse.classList.add('hide');
    ratesWrapper.innerHTML = '';
    shippingCalculate.innerHTML = window.Theme.calculating;

    if(shippingProvince == state) {
      if(shippingProvince != '' && shippingZip != '') {
        data.destination.postal_code = `${shippingZip}`;
        data.destination.province = `${shippingProvince}`;
        
        productShippingCalculate(data);
      }
    }
    else {
      shippingCalculate.innerHTML = window.Theme.calculateLabel;
      ratesResponse.classList.remove('hide');
      ratesWrapper.innerHTML = `<li><p>${window.Theme.shippingError}</p></li>`;
    }
  });
  
  // Update product quantity
  productQuantity?.addEventListener('change', function(e) {
    data.items[0].quantity = productQuantity.value;
    productShippingCalculate(data);
  });

  shippingToggle?.addEventListener('click', function(e) {
    e.preventDefault();
    shippingToggle.classList.toggle('is-open');
    shippingCalculatorWrapper.classList.toggle('hide');
  })

});
